// src/components/HowWeWork.js
import React from 'react';
import styles from './HowWeWork.module.css';

const HowWeWork = () => {
  return (
    <section
      className={styles.wrapper}
      aria-labelledby="how-we-work-heading"
    >
      <div className={styles.container}>
        <h2 id="how-we-work-heading" className={styles.title}>
          How We Work
        </h2>

        <p className={styles.subtitle}>
          A structured development process designed for reliability, scalability
          and long-term business value.
        </p>

        <div className={styles.grid}>
          <article className={styles.card}>
            <h3>Discovery & Planning</h3>
            <p>
              We begin by understanding your business goals, technical requirements
              and timelines. This phase ensures clear scope definition and prevents
              costly revisions later.
            </p>
          </article>

          <article className={styles.card}>
            <h3>Design & Architecture</h3>
            <p>
              Our team designs scalable, secure and maintainable solutions using
              modern technologies and industry best practices.
            </p>
          </article>

          <article className={styles.card}>
            <h3>Development & Quality Assurance</h3>
            <p>
              We develop in structured iterations with continuous testing, ensuring
              performance, security, and cross-device compatibility.
            </p>
          </article>

          <article className={styles.card}>
            <h3>Launch & Ongoing Support</h3>
            <p>
              After deployment, we provide monitoring, refinements and long-term
              support to ensure stability and future scalability.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
